import { useMemo } from 'react';
import chunk from 'lodash/chunk';
import find from 'lodash/find';

import NukaCarousel from '@r1-frontend/ui-react/components/NukaCarousel';
import { useWebp } from '@r1-frontend/shared/hooks/useWebp';

import ShopItemElement from '~/src/features/bundles/components/ShopItemElement';
import { TShopItemBody } from '~/src/features/bundles/types/TShopItemBody';

import * as ST from './styled';

interface IProps {
    shopItems: TShopItemBody[],
    chunkSizeForCarousel?: number,
    slidesToShow?: number,
    isOuterCardWrapperWide?: boolean,
}

const ShopItems = ({
    shopItems = [],
    chunkSizeForCarousel = 3,
    slidesToShow = 2,
    isOuterCardWrapperWide = false,
}: IProps) => {
    const isWepbSupported = useWebp();

    const shopItemsChunks = useMemo(() => shopItems
        ? chunk(shopItems, chunkSizeForCarousel)
        : [],
    [shopItems, chunkSizeForCarousel]);

    const isNotNeedCarousel = shopItems.length <= chunkSizeForCarousel;

    if (!shopItems.length) {
        return null;
    }

    return (
        <>
            {isNotNeedCarousel
                ? (
                    <ST.ShopItemsContainer
                        data-test='tariff-line-offer-card-shopItems-container'
                        isNotNeedCarousel={isNotNeedCarousel}
                    >
                        {/* @TODO При возможности убрать дублирующийся код компонента SubscriptionElement */}
                       {shopItems.map((shopItem) => (
                            <ShopItemElement
                                key={shopItem.id}
                                icon={isWepbSupported && shopItem.image_for_tariff_card_webp
                                    ? shopItem.image_for_tariff_card_webp
                                    : shopItem.image_for_tariff_card
                                }
                                title={shopItem.title}
                                text={find(shopItem.props, { name: 'name_micro' })?.value as string}
                            />
                        ))}
                    </ST.ShopItemsContainer>
                )
                : (
                    <NukaCarousel
                        slidesToShow={slidesToShow}
                        scrollMode={'page'}
                        withoutArrows
                        withoutDots={isOuterCardWrapperWide}
                        cellSpacing={8}
                        framePadding={`0 ${isOuterCardWrapperWide ? '16px' : '2px'} 32px 16px`}
                        {...isOuterCardWrapperWide
                            ? { height: '188px' }
                            : { slideWidth: '240px', height: '180px' }
                        }
                        data-test='tariff-line-offer-card-shopItems-carousel'
                    >
                        {shopItemsChunks?.map((chunkItem, chunkIdx) => (
                            <ST.ShopItemsContainer
                                key={chunkIdx}
                                data-test='tariff-line-offer-card-shopItems-container'
                            >
                                {chunkItem.map((shopItem) => (
                                    <ShopItemElement
                                        key={shopItem.id}
                                        icon={isWepbSupported && shopItem.image_for_tariff_card_webp
                                            ? shopItem.image_for_tariff_card_webp
                                            : shopItem.image_for_tariff_card
                                        }
                                        title={shopItem.title}
                                        text={find(shopItem.props, { name: 'name_micro' })?.value as string}
                                    />
                                ))}
                            </ST.ShopItemsContainer>
                        ))}
                    </NukaCarousel>
                )
            }
        </>
    );
};

export default ShopItems;
